import React, { useEffect } from "react";
import { PanelsTopLeft } from "lucide-react";

import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { SidebarToggle } from "./sidebar-toggle";
import { Menu } from "./menu";
import { useSidebarToggle } from "../../hooks/use-sidebar-toggle";
import { useStore } from "zustand";
import { useNavigate } from "react-router";
import Icon from "../../assets/images/Frame 2.svg";

export function Sidebar() {
  const navigate = useNavigate();
  const sidebar = useStore(useSidebarToggle, (state) => state);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024 && sidebar?.isOpen === false) {
        sidebar.setIsOpen(true);
      }
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [sidebar]);

  if (!sidebar) return null;

  return (
    <aside
      className={cn(
        "fixed top-0 left-0 z-20 h-screen -translate-x-full lg:translate-x-0 transition-[width] ease-in-out duration-300 bg-sidebar",
        sidebar?.isOpen === false ? "w-0" : "w-80"
      )}
    >
      <SidebarToggle isOpen={sidebar?.isOpen} setIsOpen={sidebar?.setIsOpen} />
      <div
        className={`relative h-full flex flex-col border-r py-4  ${
          sidebar?.isOpen === false ? "" : "overflow-y-auto px-3"
        }`}
      >
        <Button
          className={cn(
            "transition-transform ease-in-out duration-300 mb-1 hover:no-underline cursor-pointer",
            sidebar?.isOpen === false ? "translate-x-1" : "translate-x-0"
          )}
          variant="link"
          asChild
          onClick={() => navigate("/")}
        >
          <div
            className={`flex items-center gap-2 h-10 ${
              sidebar?.isOpen === false ? "" : ""
            }`}
          >
            {/* <PanelsTopLeft className="w-6 h-6 mr-1" /> */}
            <div className="rounded-full overflow-hidden  w-10 h-10">
              <img src={Icon} alt="Logo" />
            </div>
            <div
              className={cn(
                "text-primary text-lg",
                sidebar?.isOpen === false ? "hidden" : ""
              )}
            >
              GuideproAI
            </div>
          </div>
        </Button>
        <Menu isOpen={sidebar?.isOpen} />
      </div>
    </aside>
  );
}
